import React from 'react';
import { useIntl } from 'react-intl';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import Tooltip from '@starbucks-web/pattern-library/lib/components/tooltip';
import { sharedCallsToAction } from 'shared/app/messages/ctas';

import messages from './messages';

const ForgotUsernameLink = () => {
  const { formatMessage } = useIntl();
  return (
    <div aria-live="polite" className="relative inline-block mb2">
      <Tooltip
        bodyText={formatMessage(messages.tooltipMessage)}
        closeButtonAriaLabel={formatMessage(sharedCallsToAction.closeLabel)}
      >
        <Button
          className="px0 color-greenStarbucks text-bold text-xs"
          data-e2e="forgotUsernameLink"
          visualStyle="textLink"
        >
          {formatMessage(messages.forgotUsernameLink)}
        </Button>
      </Tooltip>
    </div>
  );
};

export default ForgotUsernameLink;
